var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","fill":"none"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#ECDCFF"}})])}
var staticRenderFns = []

export { render, staticRenderFns }